export default "__VITE_ASSET__DH3yIvJV__"